import PrivacyPolicy from "./components/PrivacyPolicy.vue";
import TermsConditions from "./components/TermsConditions.vue";
import TermsConditionsAr from "./components/termsandconditions_arabic.vue";
import PrivacyPolicyAr from "./components/privacy_policy_arabic.vue";

export default [
  { path: "/terms-of-use", component: TermsConditions },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/terms-of-use-ar", component: TermsConditionsAr },
  { path: "/privacy-policy-ar", component: PrivacyPolicyAr }
];
